// src/components/ProductDetailsP.js
import React from 'react';
import { FaAndroid, FaMicrochip, FaBatteryFull, FaMobileAlt, FaBarcode, FaFingerprint, FaWifi } from 'react-icons/fa';
import { GiMicrochip } from 'react-icons/gi';
import './ProductDetails.css';
import P80 from '../resorcesfiles/ideak/p80.jpg';
import './ProductDetails.css';
import { MdNfc } from 'react-icons/md';
import Mainmastet from '../masterpage/Mainmastet';


const ProductDetailsP = () => {
  return (
    <Mainmastet content={<>
            <div className="product-details-container">
      <h1>More Power, More Features and More Versatility</h1>
      <div className="product-content">
        <div className="product-details">
          <div className="features">
            <div className="feature-item">
              <FaAndroid size={32} />
              <p>Android 13</p>
            </div>
            <div className="feature-item">
              <FaMicrochip size={32} />
              <p>Octa-core 2.0GHz</p>
            </div>
            <div className="feature-item">
              <FaMobileAlt size={32} />
              <p>8-inch 1920x1200</p>
            </div>
            <div className="feature-item">
              <FaBatteryFull size={32} />
              <p>8700mAh Powerful Battery</p>
            </div>
          </div>
        </div>
        <div className="product-image-container">
          <img src={P80} alt="Product P80" className="product-image" />
        </div>
      </div>
      <div className="functions-container">
        <h2>Functions</h2>
        <div className="functions">
          <div className="function-item">
            <FaBarcode size={32} />
            <p>Barcode Scanning (Optional)</p>
          </div>
          <div className="function-item">
            <FaFingerprint size={32} />
            <p>Fingerprint Recognition (Optional)</p>
          </div>
          <div className="function-item">
            <MdNfc size={32} />
            <p>NFC</p>
          </div>
          <div className="function-item">
            <GiMicrochip size={32} />
            <p>UHF RFID (Optional)</p>
          </div>
          <div className="function-item">
            <FaMicrochip size={32} />
            <p>PSAM (Optional)</p>
          </div>
          <div className="function-item">
            <FaWifi size={32} />
            <p>Dual-band WIFI</p>
          </div>
        </div>
      </div>
    </div>

    </>} />
  );
};

export default ProductDetailsP;
